import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import { useState } from "react";
import Api from "../../../../constants/Api";
import { useBranch } from "../../../../context/BranchContext";
import { Col, FormLabel, Row } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import StatusFilterSelect, { DEFAULT_STATUS, buildStatusFilter } from "../../../components/Common/Filter/StatusFilterSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";

const BranchList = () => {

    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const { setBranches } = useBranch();
    const [nameFilter, setNameFilter] = useState('');
    const [cnpjFilter, setCnpjFilter] = useState('');
    // A grade já abre só com ativos, então o select nasce em Ativo: o campo mostra o recorte
    // que está valendo em vez de parecer vazio.
    const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUS);
    const [filters, setFilters] = useState([]);

    // Remove a filial da lista de filiais no header.
    const handleRemoveBranch = (branchId) => {
        setBranches(prevBranches => prevBranches.filter(branch => branch.id !== branchId));
    };

    const handleSearch = () => {
        const activeFilters = [];

        if (nameFilter && nameFilter.trim()) {
            activeFilters.push({
                field: "name",
                value: nameFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        if (cnpjFilter && cnpjFilter.trim()) {
            activeFilters.push({
                field: "document",
                value: cnpjFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        activeFilters.push(buildStatusFilter(statusFilter));

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setCnpjFilter('');
        setStatusFilter(DEFAULT_STATUS);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("branches")} motherMenu={t("main")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                <Row className="g-2 align-items-end">
                    <Col lg={4} md={6}>
                        <FormLabel>{t('name')}</FormLabel>
                        <InputText
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            placeholder={t('name')}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <FormLabel>{t('cnpj')}</FormLabel>
                        <InputText
                            value={cnpjFilter}
                            onChange={(e) => setCnpjFilter(e.target.value)}
                            placeholder={t('cnpj')}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t("branches")}
                motherMenu={t("main")}
                path={Api.main.branch}
                route={MenuConfig.main.branch.route}
                columns={Columns}
                setSelectedRows={setSelectedRows}
                filters={filters}
                hideInactiveToggle
                onDelete={(removedId) => {
                    handleRemoveBranch(removedId);
                }}
            />
        </>
    );
}

export default BranchList;
